import { PayloadAction } from 'typesafe-actions';
import { AuthorizationProviderState, AuthorizationActionTypes } from './types';

const bulkMandatesSetterHandler = (state: AuthorizationProviderState, payload: any) => {
  if (state?.bulkAuthorizations && Array.isArray(payload)) {
    return {
      ...state,
      bulkAuthorizations: payload,
    };
  }

  if (state?.bulkAuthorizations && payload !== null) {
    return {
      ...state,
      bulkAuthorizations: [...state.bulkAuthorizations, payload],
    };
  }

  if (!state?.bulkAuthorizations && Array.isArray(payload)) {
    return {
      ...state,
      bulkAuthorizations: payload,
    };
  }

  return {
    ...state,
    bulkAuthorizations: payload !== null ? [payload] : null,
  };
};

const AuthorizationReducer = (
  state: AuthorizationProviderState,
  action: PayloadAction<AuthorizationActionTypes, any>,
): AuthorizationProviderState => {
  switch (action.type) {
    case AuthorizationActionTypes.SetSelectedAuthorization:
      return {
        ...state,
        selectedAuthorization: action.payload,
      };
    case AuthorizationActionTypes.SetAuthorizationTransactionDetailsDrawer:
      return {
        ...state,
        isAuthorizationTransactionDetailsDrawerOpen: action.payload,
      };
    case AuthorizationActionTypes.SetAuthFlowDrawerOpen:
      return {
        ...state,
        isAuthFlowDrawerOpen: action.payload,
      };
    case AuthorizationActionTypes.SetRequestSpecialRate:
      return {
        ...state,
        requestSpecialRate: action.payload,
      };
    case AuthorizationActionTypes.SetAuthAction:
      return {
        ...state,
        authAction: action.payload,
      };
    case AuthorizationActionTypes.SetBulkAuthorizations:
      return bulkMandatesSetterHandler(state, action.payload);
    default: {
      return state;
    }
  }
};

export { AuthorizationReducer };
